var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeadset = function SvgIconHeadset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.08 13.805a1.5 1.5 0 0 0-1.837-1.06l-1.056.282a3 3 0 0 0-2.121 3.675l.748 2.79a2 2 0 0 0 2.45 1.415l1.52-.408c.518-.139.958-.48 1.225-.946s.338-1.019.199-1.538zM5.5 13.71a.5.5 0 0 1 .613.354l1.128 4.21c.07.265.034.547-.1.783a1.01 1.01 0 0 1-.618.476l-1.52.408a1 1 0 0 1-1.224-.707l-.748-2.791a2 2 0 0 1 1.414-2.45zM16.92 13.805a1.5 1.5 0 0 1 1.837-1.06l1.056.282a3 3 0 0 1 2.121 3.675l-.747 2.79a2 2 0 0 1-2.45 1.415l-1.52-.408a2.01 2.01 0 0 1-1.226-.946 2.04 2.04 0 0 1-.198-1.538zm1.579-.095a.5.5 0 0 0-.613.354l-1.128 4.21c-.07.265-.034.547.101.783s.357.407.617.476l1.52.408a1 1 0 0 0 1.225-.707l.747-2.791a2 2 0 0 0-1.414-2.45z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.899 12.551a9.1 9.1 0 1 1 18.2 0v1.4a.5.5 0 1 1-1 0v-1.4a8.1 8.1 0 1 0-16.2 0v1.4a.5.5 0 0 1-1 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHeadset;